<template>
    <div class="layout-1200 padding-top-50 padding-bottom-50">
        <div class="path flex-row">
            <p class="page hover-pointer hover-yellow" @click="closeCategory">{{page}}</p>
            <p :class="['category', {'hover-pointer': selected_product, 'hover-yellow': selected_product, 'gray': selected_product}]" @click="selected_product = null">- {{category.name}}</p>
            <p class="product" v-if="selected_product">- {{selected_product.name}}</p>
        </div>
        <div v-if="!selected_product">
            <div class="loader flex-column flex-center" v-if="products.length === 0">
                <img class="loader-img" src="../../assets/logo-loader.svg"/>
                <p style="color: white; font-size: 14px; margin-top: 50px;">Загружаем данные...</p>
            </div>
            <or-product-card class="card" v-for="product in products_sorted" :key="product.name" :options="product" @click="select(product)"/>
        </div>
        <div v-else>
            <or-product-page :items="selected_product.content" :scroll_top="own_scroll_top" @close="selected_product = null"/>
        </div>
    </div>
</template>

<script>
import orProductCard from "./or-product-card.vue"
import orProductPage from "./or-product-page.vue"
export default {
    components: {orProductCard, orProductPage},
    props: {
        products: Array,
        page: String,
        category: String,
        scroll_top: Number,
    },
    data() {
        return {
            selected_product: null,
            own_scroll_top: 0,
        }
    },
    computed: {
        products_sorted() {
            const sorted = [];
            const sort = this.category.sort;
            this.products.map(product=>{
                sorted[sort.indexOf(product.id)] = product;
            })
            return sorted;
        }
    },
    mounted() {
        window.scrollTo(0,0);
    },
    unmounted() {
        window.scrollTo(0, this.scroll_top);
    },
    methods: {
        closeCategory() {
            this.$emit('close');
        },
        select(product) {
            this.selected_product = product;
            this.own_scroll_top = window.scrollY;
        }
    }
}
</script>

<style scoped>
    .card {
        margin-bottom: 50px;
    }
    .card:last-of-type {
        margin-bottom: 0;
    }
    .path {
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 50px;
    }
    .page {
        color: #4F4F4F;
    }
    .category {
        color: #ffffff;
        margin-left: 5px;
    }
    .product {
        color: #ffffff;
        margin-left: 5px;
    }
    .gray {
        color: #4F4F4F;
    }
    .loader {
        position: fixed;
        top: 320px;
        left: 0;
        width: 100vw;
        /* max-width: 100%; */
        height: calc(100vh - 320px);
        z-index: 999999;
        background-color: black;
    }
    @keyframes loader {
        from {transform: rotate(0);}
        to {transform: rotate(1080deg);}
    }
    .loader-img {
        animation-name: loader;
        animation-duration: 2s;
        animation-iteration-count: infinite;
        animation-timing-function: ease-in-out;
    }
</style>